import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type GetEntityTypeParameters = { id: EntityTypeId }

const getEntityType = async ({ id }: GetEntityTypeParameters): Promise<EntityType | null> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}`,
    {
      headers: {
        Accept: 'application/json',
      },
    }
  ).then(async (response) => {
    switch (response.status) {
      case 200:
        return EntityType.fromJsonString(await response.text())
      case 404:
        console.warn(`Got status ${response.status} from getEntityType endpoint`)
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getEntityType endpoint`)
    }
  })
}

export default getEntityType
